import { E as EmblaCarousel } from './embla-carousel.esm-CCUHK2kO.js';
import { A as Autoplay } from './embla-carousel-autoplay.esm-BukruCx2.js';
import { o as observeCarouselVisibility } from './visibility-1aJUVV5h.js';

class AnnouncementBar extends HTMLElement {
  /** @type {import('embla-carousel').EmblaCarouselType | undefined} */
  #embla;
  #autoplayDelay = parseInt(this.dataset.autoplayDelay);
  /** @type {ReturnType<typeof observeCarouselVisibility> | null} */
  #visibility = null;

  connectedCallback() {
    this.#visibility = observeCarouselVisibility(this, {
      onEnter: () => {
        this.#embla = EmblaCarousel(
          this.querySelector('.embla__viewport'),
          {
            direction: document.dir || 'ltr',
            active: this.querySelectorAll('.embla__slide').length > 1,
            loop: true,
          },
          [Autoplay({ delay: this.#autoplayDelay })]
        );
      },
      getEmbla: () => this.#embla,
    });
  }

  disconnectedCallback() {
    this.#visibility?.disconnect();
    this.#embla?.destroy();
    this.#embla = undefined;
  }
}

customElements.define('announcement-bar', AnnouncementBar);
